import { RESOURCE_URI } from 'shared/constants/global';
import { TaletsOfClassType } from 'shared/constants/talentsData';

export const hunter: TaletsOfClassType[] = [{
  title: 'beast_mastery',
  backgroundImage: `${RESOURCE_URI}/talents/backgrounds/wrath/361.jpg`,
  icon: `${RESOURCE_URI}/icons/large/ability_hunter_beasttaming.jpg`,
  talents: [
    {
      id: 'hunter_beast_mastery_improved_aspect_of_the_hawk',
      title: 'Improved Aspect of the Hawk',
      description: {
        1: 'While Aspect of the Hawk or Dragonhawk is active, all normal ranged attacks have a 10% chance of increasing ranged attack speed by 3% for 12 sec.',
        2: 'While Aspect of the Hawk or Dragonhawk is active, all normal ranged attacks have a 10% chance of increasing ranged attack speed by 6% for 12 sec.',
        3: 'While Aspect of the Hawk or Dragonhawk is active, all normal ranged attacks have a 10% chance of increasing ranged attack speed by 9% for 12 sec.',
        4: 'While Aspect of the Hawk or Dragonhawk is active, all normal ranged attacks have a 10% chance of increasing ranged attack speed by 12% for 12 sec.',
        5: 'While Aspect of the Hawk or Dragonhawk is active, all normal ranged attacks have a 10% chance of increasing ranged attack speed by 15% for 12 sec.',
      },
      icon: `${RESOURCE_URI}/icons/large/spell_nature_ravenform.jpg`,
      tier: 1,
      column: 2,
      max: 5,
    },
    {
      id: 'hunter_beast_mastery_endurance_training',
      title: 'Endurance Training',
      description: {
        1: 'Increases the health of your pet by 2% and your total health by 1%.',
        2: 'Increases the health of your pet by 4% and your total health by 2%.',
        3: 'Increases the health of your pet by 6% and your total health by 3%.',
        4: 'Increases the health of your pet by 8% and your total health by 4%.',
        5: 'Increases the health of your pet by 10% and your total health by 5%.',
      },
      icon: `${RESOURCE_URI}/icons/large/spell_nature_reincarnation.jpg`,
      tier: 1,
      column: 3,
      max: 5,
    },
    {
      id: 'hunter_beast_mastery_focused_fire',
      title: 'Focused Fire',
      description: {
        1: 'All damage caused by you is increased by 1% while your pet is active and the critical strike chance of your pet\'s special abilities is increased by 10% while Kill Command is active.',
        2: 'All damage caused by you is increased by 2% while your pet is active and the critical strike chance of your pet\'s special abilities is increased by 20% while Kill Command is active.',
      },
      icon: `${RESOURCE_URI}/icons/large/ability_hunter_silenthunter.jpg`,
      tier: 2,
      column: 1,
      max: 2,
    }, {
      id: 'hunter_beast_mastery_improved_aspect_of_the_monkey',
      title: 'Improved Aspect of the Monkey',
      description: {
        1: 'Increases the Dodge bonus of your Aspect of the Monkey and Aspect of the Dragonhawk by 2%.',
        2: 'Increases the Dodge bonus of your Aspect of the Monkey and Aspect of the Dragonhawk by 4%.',
        3: 'Increases the Dodge bonus of your Aspect of the Monkey and Aspect of the Dragonhawk by 6%.',
      },
      icon: `${RESOURCE_URI}/icons/large/ability_hunter_aspectofthemonkey.jpg`,
      tier: 2,
      column: 2,
      max: 3,
    }, {
      id: 'hunter_beast_mastery_thick_hide',
      title: 'Thick Hide',
      description: {
        1: 'Increases the armor rating of your pets by 7% and your armor contribution from items by 4%.',
        2: 'Increases the armor rating of your pets by 14% and your armor contribution from items by 7%.',
        3: 'Increases the armor rating of your pets by 20% and your armor contribution from items by 10%.',
      },
      icon: `${RESOURCE_URI}/icons/large/inv_misc_pelt_bear_03.jpg`,
      tier: 2,
      column: 3,
      max: 3,
    }, {
      id: 'hunter_beast_mastery_improved_revive_pet',
      title: 'Improved Revive Pet',
      description: {
        1: 'Revive Pet\'s casting time is reduced by 3 sec, mana cost is reduced by 20%, and increases the health your pet returns with by an additional 15%.',
        2: 'Revive Pet\'s casting time is reduced by 6 sec, mana cost is reduced by 40%, and increases the health your pet returns with by an additional 30%.',
      },
      icon: `${RESOURCE_URI}/icons/large/ability_hunter_beastsoothe.jpg`,
      tier: 2,
      column: 4,
      max: 2,
    }, {
      id: 'hunter_beast_mastery_pathfinding',
      title: 'Pathfinding',
      description: {
        1: 'Increases the speed bonus of your Aspect of the Cheetah and Aspect of the Pack by 4%, and increases your speed while mounted by 5%. The mounted movement speed increase does not stack with other effects.',
        2: 'Increases the speed bonus of your Aspect of the Cheetah and Aspect of the Pack by 8%, and increases your speed while mounted by 10%. The mounted movement speed increase does not stack with other effects.',
      },
      icon: `${RESOURCE_URI}/icons/large/ability_mount_jungletiger.jpg`,
      tier: 3,
      column: 1,
      max: 2,
    }, {
      id: 'hunter_beast_mastery_aspect_mastery',
      title: 'Aspect Mastery',
      description: {
        1: 'Aspect of the Viper - Reduces the damage penalty by 10%. Aspect of the Monkey - Reduces the damage done to you while active by 5%. Aspect of the Hawk - Increases the attack power bonus by 30%. Aspect of the Dragonhawk - Combines the bonuses from Aspect of the Monkey and Hawk.',
      },
      icon: `${RESOURCE_URI}/icons/large/ability_hunter_aspectmastery.jpg`,
      tier: 3,
      column: 2,
      max: 1,
    }, {
      id: 'hunter_beast_mastery_unleashed_fury',
      title: 'Unleashed Fury',
      description: {
        1: 'Increases the damage done by your pets by 3%.',
        2: 'Increases the damage done by your pets by 6%.',
        3: 'Increases the damage done by your pets by 9%.',
        4: 'Increases the damage done by your pets by 12%.',
        5: 'Increases the damage done by your pets by 15%.',
      },
      icon: `${RESOURCE_URI}/icons/large/ability_bullrush.jpg`,
      tier: 3,
      column: 3,
      max: 5,
    }, {
      id: 'hunter_beast_mastery_improved_mend_pet',
      title: 'Improved Mend Pet',
      description: {
        1: 'Reduces the mana cost of your Mend Pet spell by 10% and gives the Mend Pet spell a 25% chance of cleansing 1 Curse, Disease, Magic or Poison effect from the pet each tick.',
        2: 'Reduces the mana cost of your Mend Pet spell by 10% and gives the Mend Pet spell a 50% chance of cleansing 1 Curse, Disease, Magic or Poison effect from the pet each tick.',
      },
      icon: `${RESOURCE_URI}/icons/large/ability_hunter_mendpet.jpg`,
      tier: 4,
      column: 2,
      max: 2,
    }, {
      id: 'hunter_beast_mastery_ferocity',
      title: 'Ferocity',
      description: {
        1: 'Increases the critical strike chance of your pet by 2%.',
        2: 'Increases the critical strike chance of your pet by 4%.',
        3: 'Increases the critical strike chance of your pet by 6%.',
        4: 'Increases the critical strike chance of your pet by 8%.',
        5: 'Increases the critical strike chance of your pet by 10%.',
      },
      icon: `${RESOURCE_URI}/icons/large/inv_misc_monsterclaw_04.jpg`,
      tier: 4,
      column: 3,
      max: 5,
    }, {
      id: 'hunter_beast_mastery_spirit_bond',
      title: 'Spirit Bond',
      description: {
        1: 'While your pet is active, you and your pet will regenerate 1% of total health every 10 sec., and increases healing done to you and your pet by 5%.',
        2: 'While your pet is active, you and your pet will regenerate 2% of total health every 10 sec., and increases healing done to you and your pet by 10%.',
      },
      icon: `${RESOURCE_URI}/icons/large/classic_ability_druid_demoralizingroar.jpg`,
      tier: 5,
      column: 1,
      max: 2,
    }, {
      id: 'hunter_beast_mastery_intimidation',
      title: 'Intimidation',
      description: {
        1: 'Command your pet to intimidate the target, causing a high amount of threat and stunning the target for 3 sec. Lasts 15 sec.',
      },
      icon: `${RESOURCE_URI}/icons/large/ability_devour.jpg`,
      tier: 5,
      column: 2,
      max: 1,
      costs: '8% of base mana',
      castDuration: 'instant',
      range: 100,
      cooldown: 60,
    }, {
      id: 'hunter_beast_mastery_bestial_discipline',
      title: 'Bestial Discipline',
      description: {
        1: 'Increases the Focus regeneration of your pets by 50%.',
        2: 'Increases the Focus regeneration of your pets by 100%.',
      },
      icon: `${RESOURCE_URI}/icons/large/spell_nature_abolishmagic.jpg`,
      tier: 5,
      column: 4,
      max: 2,
    }, {
      id: 'hunter_beast_mastery_animal_handler',
      title: 'Animal Handler',
      description: {
        1: 'Increases your pet\'s attack power by 5%, and increases the duration of your Master\'s Call effect by 3 sec.',
        2: 'Increases your pet\'s attack power by 10%, and increases the duration of your Master\'s Call effect by 6 sec.',
      },
      icon: `${RESOURCE_URI}/icons/large/ability_hunter_animalhandler.jpg`,
      tier: 6,
      column: 1,
      max: 2,
    }, {
      id: 'hunter_beast_mastery_frenzy',
      title: 'Frenzy',
      description: {
        1: 'Gives your pet a 20% chance to gain a 30% attack speed increase for 8 sec after dealing a critical strike.',
        2: 'Gives your pet a 40% chance to gain a 30% attack speed increase for 8 sec after dealing a critical strike.',
        3: 'Gives your pet a 60% chance to gain a 30% attack speed increase for 8 sec after dealing a critical strike.',
        4: 'Gives your pet a 80% chance to gain a 30% attack speed increase for 8 sec after dealing a critical strike.',
        5: 'Gives your pet a 100% chance to gain a 30% attack speed increase for 8 sec after dealing a critical strike.',
      },
      icon: `${RESOURCE_URI}/icons/large/inv_misc_monsterclaw_03.jpg`,
      tier: 6,
      column: 3,
      max: 5,
      required: 'hunter_beast_mastery_ferocity',
    }, {
      id: 'hunter_beast_mastery_ferocious_inspiration',
      title: 'Ferocious Inspiration',
      description: {
        1: 'All party and raid members have all damage increased by 1% within 100 yards of your pet. In addition, increases the damage dealt by Arcane Shot and Steady Shot by 3%.',
        2: 'All party and raid members have all damage increased by 2% within 100 yards of your pet. In addition, increases the damage dealt by Arcane Shot and Steady Shot by 6%.',
        3: 'All party and raid members have all damage increased by 3% within 100 yards of your pet. In addition, increases the damage dealt by Arcane Shot and Steady Shot by 9%.',
      },
      icon: `${RESOURCE_URI}/icons/large/ability_hunter_ferociousinspiration.jpg`,
      tier: 7,
      column: 1,
      max: 3,
    }, {
      id: 'hunter_beast_mastery_bestial_wrath',
      title: 'Bestial Wrath',
      description: {
        1: 'Send your pet into a rage causing 50% additional damage for 10 sec. While enraged, the beast does not feel pity or remorse or fear and it cannot be stopped unless killed.',
      },
      icon: `${RESOURCE_URI}/icons/large/ability_druid_ferociousbite.jpg`,
      tier: 7,
      column: 2,
      max: 1,
      castDuration: 'instant',
      cooldown: 60,
      costs: '10% of base mana',
      range: 100,
      required: 'hunter_beast_mastery_intimidation',
    }, {
      id: 'hunter_beast_mastery_catlike_reflexes',
      title: 'Catlike Reflexes',
      description: {
        1: 'Increases your chance to dodge by 1% and your pet\'s chance to dodge by an additional 3%. In addition, reduces the cooldown of your Kill Command ability by 10 sec.',
        2: 'Increases your chance to dodge by 2% and your pet\'s chance to dodge by an additional 6%. In addition, reduces the cooldown of your Kill Command ability by 20 sec.',
        3: 'Increases your chance to dodge by 3% and your pet\'s chance to dodge by an additional 9%. In addition, reduces the cooldown of your Kill Command ability by 30 sec.',
      },
      icon: `${RESOURCE_URI}/icons/large/ability_hunter_catlikereflexes.jpg`,
      tier: 7,
      column: 3,
      max: 3,
    }, {
      id: 'hunter_beast_mastery_invigoration',
      title: 'Invigoration',
      description: {
        1: 'When your pet scores a critical hit with a special ability, you have a 50% chance to instantly regenerate 1% mana.',
        2: 'When your pet scores a critical hit with a special ability, you have a 100% chance to instantly regenerate 1% mana.',
      },
      icon: `${RESOURCE_URI}/icons/large/ability_hunter_invigeration.jpg`,
      tier: 8,
      column: 1,
      max: 2,
      required: 'hunter_beast_mastery_ferocious_inspiration',
    }, {
      id: 'hunter_beast_mastery_serpents_swiftness',
      title: 'Serpent\'s Swiftness',
      description: {
        1: 'Increases ranged combat attack speed by 4% and your pet\'s melee attack speed by 4%.',
        2: 'Increases ranged combat attack speed by 8% and your pet\'s melee attack speed by 8%.',
        3: 'Increases ranged combat attack speed by 12% and your pet\'s melee attack speed by 12%.',
        4: 'Increases ranged combat attack speed by 16% and your pet\'s melee attack speed by 16%.',
        5: 'Increases ranged combat attack speed by 20% and your pet\'s melee attack speed by 20%.',
      },
      icon: `${RESOURCE_URI}/icons/large/ability_hunter_serpentswiftness.jpg`,
      tier: 8,
      column: 3,
      max: 5,
    }, {
      id: 'hunter_beast_mastery_longevity',
      title: 'Longevity',
      description: {
        1: 'Reduces the cooldown of your Bestial Wrath, Intimidation and Pet Special Abilities by 10%.',
        2: 'Reduces the cooldown of your Bestial Wrath, Intimidation and Pet Special Abilities by 20%.',
        3: 'Reduces the cooldown of your Bestial Wrath, Intimidation and Pet Special Abilities by 30%.',
      },
      icon: `${RESOURCE_URI}/icons/large/ability_hunter_longevity.jpg`,
      tier: 9,
      column: 1,
      max: 3,
    }, {
      id: 'hunter_beast_mastery_the_beast_within',
      title: 'The Beast Within',
      description: {
        1: 'Increases all damage you deal by 10% and while your pet is under the effects of Bestial Wrath, you also go into a rage causing 10% additional damage and reducing mana costs of all spells by 50% for 10 sec. While enraged, you do not feel pity or remorse or fear and you cannot be stopped unless killed.',
      },
      icon: `${RESOURCE_URI}/icons/large/ability_hunter_beastwithin.jpg`,
      tier: 9,
      column: 2,
      max: 1,
      required: 'hunter_beast_mastery_bestial_wrath',
    }, {
      id: 'hunter_beast_mastery_cobra_strikes',
      title: 'Cobra Strikes',
      description: {
        2: 'You have a 20% chance when you critically hit with Arcane Shot, Steady Shot or Kill Shot to cause your pet\'s next 2 special attacks to critically hit.',
        1: 'You have a 40% chance when you critically hit with Arcane Shot, Steady Shot or Kill Shot to cause your pet\'s next 2 special attacks to critically hit.',
        3: 'You have a 60% chance when you critically hit with Arcane Shot, Steady Shot or Kill Shot to cause your pet\'s next 2 special attacks to critically hit.',
      },
      icon: `${RESOURCE_URI}/icons/large/ability_hunter_cobrastrikes.jpg`,
      tier: 9,
      column: 3,
      max: 3,
    }, {
      id: 'hunter_beast_mastery_kindred_spirits',
      title: 'Kindred Spirits',
      description: {
        1: 'Increases your pet\'s damage by 4% and you and your pet\'s movement speed by 2% while your pet is active. This does not stack with other movement speed increasing effects.',
        2: 'Increases your pet\'s damage by 8% and you and your pet\'s movement speed by 4% while your pet is active. This does not stack with other movement speed increasing effects.',
        3: 'Increases your pet\'s damage by 12% and you and your pet\'s movement speed by 6% while your pet is active. This does not stack with other movement speed increasing effects.',
        4: 'Increases your pet\'s damage by 16% and you and your pet\'s movement speed by 8% while your pet is active. This does not stack with other movement speed increasing effects.',
        5: 'Increases your pet\'s damage by 20% and you and your pet\'s movement speed by 10% while your pet is active. This does not stack with other movement speed increasing effects.',
      },
      icon: `${RESOURCE_URI}/icons/large/ability_hunter_separationanxiety.jpg`,
      tier: 10,
      column: 2,
      max: 5,
    }, {
      id: 'hunter_beast_mastery_beast_mastery',
      title: 'Beast Mastery',
      description: {
        1: 'You master the art of Beast training, teaching you the ability to tame Exotic pets and increasing your total amount of Pet Skill Points by 4.',
      },
      icon: `${RESOURCE_URI}/icons/large/ability_hunter_beastmastery.jpg`,
      tier: 11,
      column: 2,
      max: 1,
    },
  ],
}, {
  title: 'marksmanship',
  backgroundImage: `${RESOURCE_URI}/talents/backgrounds/wrath/363.jpg`,
  icon: `${RESOURCE_URI}/icons/large/ability_marksmanship.jpg`,
  talents: [
    {
      id: 'hunter_marksmanship_improved_concussive_shot',
      title: 'Improved Concussive Shot',
      description: {
        1: 'Increases the duration of your Concussive Shot\'s daze effect by 1 sec.',
        2: 'Increases the duration of your Concussive Shot\'s daze effect by 2 sec.',
      },
      icon: `${RESOURCE_URI}/icons/large/spell_frost_stun.jpg`,
      tier: 1,
      column: 1,
      max: 2,
    },
    {
      id: 'hunter_marksmanship_focused_aim',
      title: 'Focused Aim',
      description: {
        1: 'Reduces the pushback suffered from damaging attacks while casting Steady Shot by 23%, and increases your chance to hit by 1%.',
        2: 'Reduces the pushback suffered from damaging attacks while casting Steady Shot by 46%, and increases your chance to hit by 2%.',
        3: 'Reduces the pushback suffered from damaging attacks while casting Steady Shot by 70%, and increases your chance to hit by 3%.',
      },
      icon: `${RESOURCE_URI}/icons/large/ability_hunter_focusedaim.jpg`,
      tier: 1,
      column: 2,
      max: 3,
    },
    {
      id: 'hunter_marksmanship_lethal_shots',
      title: 'Lethal Shots',
      description: {
        1: 'Increases your critical strike chance with ranged weapons by 1%.',
        2: 'Increases your critical strike chance with ranged weapons by 2%.',
        3: 'Increases your critical strike chance with ranged weapons by 3%.',
        4: 'Increases your critical strike chance with ranged weapons by 4%.',
        5: 'Increases your critical strike chance with ranged weapons by 5%.',
      },
      icon: `${RESOURCE_URI}/icons/large/ability_searingarrow.jpg`,
      tier: 1,
      column: 3,
      max: 5,
    },
    {
      id: 'hunter_marksmanship_careful_aim',
      title: 'Careful Aim',
      description: {
        1: 'Increases your ranged attack power by an amount equal to 33% of your total Intellect.',
        2: 'Increases your ranged attack power by an amount equal to 66% of your total Intellect.',
        3: 'Increases your ranged attack power by an amount equal to 100% of your total Intellect.',
      },
      icon: `${RESOURCE_URI}/icons/large/ability_hunter_zenarchery.jpg`,
      tier: 2,
      column: 1,
      max: 3,
    },
    {
      id: 'hunter_marksmanship_improved_hunters_mark',
      title: 'Improved Hunter\'s Mark',
      description: {
        1: 'Increases the bonus attack power granted by your Hunter\'s Mark ability by 10%, and reduces the mana cost of your Hunter\'s Mark ability by 33%.',
        2: 'Increases the bonus attack power granted by your Hunter\'s Mark ability by 20%, and reduces the mana cost of your Hunter\'s Mark ability by 66%.',
        3: 'Increases the bonus attack power granted by your Hunter\'s Mark ability by 30%, and reduces the mana cost of your Hunter\'s Mark ability by 100%.',
      },
      icon: `${RESOURCE_URI}/icons/large/ability_hunter_snipershot.jpg`,
      tier: 2,
      column: 2,
      max: 3,
    },
    {
      id: 'hunter_marksmanship_mortal_shots',
      title: 'Mortal Shots',
      description: {
        1: 'Increases the critical strike damage bonus of your ranged abilities by 6%.',
        2: 'Increases the critical strike damage bonus of your ranged abilities by 12%.',
        3: 'Increases the critical strike damage bonus of your ranged abilities by 18%.',
        4: 'Increases the critical strike damage bonus of your ranged abilities by 24%.',
        5: 'Increases the critical strike damage bonus of your ranged abilities by 30%.',
      },
      icon: `${RESOURCE_URI}/icons/large/ability_piercedamage.jpg`,
      tier: 2,
      column: 3,
      max: 5,
    },
    {
      id: 'hunter_marksmanship_go_for_the_throat',
      title: 'Go for the Throat',
      description: {
        1: 'Your ranged critical hits cause your pet to generate 25 Focus.',
        2: 'Your ranged critical hits cause your pet to generate 50 Focus.',
      },
      icon: `${RESOURCE_URI}/icons/large/ability_hunter_goforthethroat.jpg`,
      tier: 3,
      column: 1,
      max: 2,
    },
    {
      id: 'hunter_marksmanship_improved_arcane_shot',
      title: 'Improved Arcane Shot',
      description: {
        1: 'Increases the damage done by your Arcane Shot by 5%.',
        2: 'Increases the damage done by your Arcane Shot by 10%.',
        3: 'Increases the damage done by your Arcane Shot by 15%.',
      },
      icon: `${RESOURCE_URI}/icons/large/ability_impalingbolt.jpg`,
      tier: 3,
      column: 2,
      max: 3,
    },
    {
      id: 'hunter_marksmanship_aimed_shot',
      title: 'Aimed Shot',
      description: {
        1: 'An aimed shot that increases ranged damage by 5 and reduces healing done to that target by 50%. Lasts 10 sec.',
      },
      icon: `${RESOURCE_URI}/icons/large/inv_spear_07.jpg`,
      tier: 3,
      column: 3,
      max: 1,
      castDuration: 'instant',
      cooldown: 10,
      costs: '8% of base mana',
      range: 35,
      required: 'hunter_marksmanship_mortal_shots',
    },
    {
      id: 'hunter_marksmanship_rapid_killing',
      title: 'Rapid Killing',
      description: {
        1: 'Reduces the cooldown of your Rapid Fire ability by 1 min. In addition, after killing an opponent that yields experience or honor, your next Aimed Shot, Arcane Shot or Chimera Shot causes 10% additional damage. Lasts 20 sec.',
        2: 'Reduces the cooldown of your Rapid Fire ability by 2 min. In addition, after killing an opponent that yields experience or honor, your next Aimed Shot, Arcane Shot or Chimera Shot causes 20% additional damage. Lasts 20 sec.',
      },
      icon: `${RESOURCE_URI}/icons/large/ability_hunter_rapidkilling.jpg`,
      tier: 3,
      column: 4,
      max: 2,
    },
    {
      id: 'hunter_marksmanship_improved_stings',
      title: 'Improved Stings',
      description: {
        1: 'Increases the damage done by your Serpent Sting and Wyvern Sting by 10% and the mana drained by your Viper Sting by 10%. In addition, reduces the chance your Sting damage over time effects will be dispelled by 10%.',
        2: 'Increases the damage done by your Serpent Sting and Wyvern Sting by 20% and the mana drained by your Viper Sting by 20%. In addition, reduces the chance your Sting damage over time effects will be dispelled by 20%.',
        3: 'Increases the damage done by your Serpent Sting and Wyvern Sting by 30% and the mana drained by your Viper Sting by 30%. In addition, reduces the chance your Sting damage over time effects will be dispelled by 30%.',
      },
      icon: `${RESOURCE_URI}/icons/large/ability_hunter_quickshot.jpg`,
      tier: 4,
      column: 2,
      max: 3,
    }, {
      id: 'hunter_marksmanship_efficiency',
      title: 'Efficiency',
      description: {
        1: 'Reduces the Mana cost of your Shots and Stings by 3%.',
        2: 'Reduces the Mana cost of your Shots and Stings by 6%.',
        3: 'Reduces the Mana cost of your Shots and Stings by 9%.',
        4: 'Reduces the Mana cost of your Shots and Stings by 12%.',
        5: 'Reduces the Mana cost of your Shots and Stings by 15%.',
      },
      icon: `${RESOURCE_URI}/icons/large/spell_frost_wizardmark.jpg`,
      tier: 4,
      column: 3,
      max: 5,
    }, {
      id: 'hunter_marksmanship_concussive_barrage',
      title: 'Concussive Barrage',
      description: {
        1: 'Your successful Chimera Shot and Multi-Shot attacks have a 50% chance to Daze the target for 4 sec.',
        2: 'Your successful Chimera Shot and Multi-Shot attacks have a 100% chance to Daze the target for 4 sec.',
      },
      icon: `${RESOURCE_URI}/icons/large/spell_arcane_starfire.jpg`,
      tier: 5,
      column: 1,
      max: 2,
    }, {
      id: 'hunter_marksmanship_readiness',
      title: 'Readiness',
      description: {
        1: 'When activated, this ability immediately finishes the cooldown on your other Hunter abilities except Bestial Wrath.',
      },
      icon: `${RESOURCE_URI}/icons/large/ability_hunter_readiness.jpg`,
      tier: 5,
      column: 2,
      max: 1,
      castDuration: 'instant',
      cooldown: 180,
    }, {
      id: 'hunter_marksmanship_barrage',
      title: 'Barrage',
      description: {
        1: 'Increases the damage done by your Multi-Shot, Aimed Shot, and Volley spells by 4%.',
        2: 'Increases the damage done by your Multi-Shot, Aimed Shot, and Volley spells by 8%.',
        3: 'Increases the damage done by your Multi-Shot, Aimed Shot, and Volley spells by 12%.',
      },
      icon: `${RESOURCE_URI}/icons/large/ability_upgrademoonglaive.jpg`,
      tier: 5,
      column: 3,
      max: 3,
    }, {
      id: 'hunter_marksmanship_combat_experience',
      title: 'Combat Experience',
      description: {
        1: 'Increases your total Agility and Intellect by 2%.',
        2: 'Increases your total Agility and Intellect by 4%.',
      },
      icon: `${RESOURCE_URI}/icons/large/ability_hunter_combatexperience.jpg`,
      tier: 6,
      column: 1,
      max: 2,
    }, {
      id: 'hunter_marksmanship_ranged_weapon_specialization',
      title: 'Ranged Weapon Specialization',
      description: {
        1: 'Increases the damage you deal with ranged weapons by 1%.',
        2: 'Increases the damage you deal with ranged weapons by 3%.',
        3: 'Increases the damage you deal with ranged weapons by 5%.',
      },
      icon: `${RESOURCE_URI}/icons/large/inv_weapon_rifle_06.jpg`,
      tier: 6,
      column: 4,
      max: 3,
    }, {
      id: 'hunter_marksmanship_piercing_shots',
      title: 'Piercing Shots',
      description: {
        1: 'Your critical Aimed, Steady and Chimera Shots cause the target to bleed for 10% of the damage dealt over 8 sec.',
        2: 'Your critical Aimed, Steady and Chimera Shots cause the target to bleed for 20% of the damage dealt over 8 sec.',
        3: 'Your critical Aimed, Steady and Chimera Shots cause the target to bleed for 30% of the damage dealt over 8 sec.',
      },
      icon: `${RESOURCE_URI}/icons/large/ability_hunter_piercingshots.jpg`,
      tier: 7,
      column: 1,
      max: 3,
    }, {
      id: 'hunter_marksmanship_trueshot_aura',
      title: 'Trueshot Aura',
      description: {
        1: 'Increases the attack power of party and raid members within 100 yards by 10%. Lasts until cancelled.',
      },
      icon: `${RESOURCE_URI}/icons/large/ability_trueshot.jpg`,
      tier: 7,
      column: 2,
      max: 1,
      castDuration: 'instant',
      required: 'hunter_marksmanship_readiness',
    }, {
      id: 'hunter_marksmanship_improved_barrage',
      title: 'Improved Barrage',
      description: {
        1: 'Increases the critical strike chance of your Multi-Shot and Aimed Shot abilities by 4% and reduces the pushback suffered from damaging attacks while channeling Volley by 33%.',
        2: 'Increases the critical strike chance of your Multi-Shot and Aimed Shot abilities by 8% and reduces the pushback suffered from damaging attacks while channeling Volley by 66%.',
        3: 'Increases the critical strike chance of your Multi-Shot and Aimed Shot abilities by 12% and reduces the pushback suffered from damaging attacks while channeling Volley by 100%.',
      },
      icon: `${RESOURCE_URI}/icons/large/ability_upgrademoonglaive.jpg`,
      tier: 7,
      column: 3,
      max: 3,
      required: 'hunter_marksmanship_barrage',
    }, {
      id: 'hunter_marksmanship_master_marksman',
      title: 'Master Marksman',
      description: {
        1: 'Increases your critical strike chance by 1%, and reduces the Mana cost of your Steady Shot, Aimed Shot, and Chimera Shot by 5%.',
        2: 'Increases your critical strike chance by 2%, and reduces the Mana cost of your Steady Shot, Aimed Shot, and Chimera Shot by 10%.',
        3: 'Increases your critical strike chance by 3%, and reduces the Mana cost of your Steady Shot, Aimed Shot, and Chimera Shot by 15%.',
        4: 'Increases your critical strike chance by 4%, and reduces the Mana cost of your Steady Shot, Aimed Shot, and Chimera Shot by 20%.',
        5: 'Increases your critical strike chance by 5%, and reduces the Mana cost of your Steady Shot, Aimed Shot, and Chimera Shot by 25%.',
      },
      icon: `${RESOURCE_URI}/icons/large/ability_hunter_mastermarksman.jpg`,
      tier: 8,
      column: 2,
      max: 5,
    }, {
      id: 'hunter_marksmanship_rapid_recuperation',
      title: 'Rapid Recuperation',
      description: {
        1: 'You gain 2% of your mana every 3 sec while under the effect of Rapid Fire, and you gain 1% of your mana every 2 sec for 6 sec when you gain Rapid Killing.',
        2: 'You gain 4% of your mana every 3 sec while under the effect of Rapid Fire, and you gain 2% of your mana every 2 sec for 6 sec when you gain Rapid Killing.',
      },
      icon: `${RESOURCE_URI}/icons/large/ability_hunter_rapidregeneration.jpg`,
      tier: 8,
      column: 3,
      max: 2,
    }, {
      id: 'hunter_marksmanship_wild_quiver',
      title: 'Wild Quiver',
      description: {
        1: 'You have a 4% chance to shoot an additional shot when doing damage with your auto shot, dealing 80% weapon nature damage. Wild Quiver consumes no ammo.',
        2: 'You have a 8% chance to shoot an additional shot when doing damage with your auto shot, dealing 80% weapon nature damage. Wild Quiver consumes no ammo.',
        3: 'You have a 12% chance to shoot an additional shot when doing damage with your auto shot, dealing 80% weapon nature damage. Wild Quiver consumes no ammo.',
      },
      icon: `${RESOURCE_URI}/icons/large/ability_hunter_wildquiver.jpg`,
      tier: 9,
      column: 1,
      max: 3,
    }, {
      id: 'hunter_marksmanship_silencing_shot',
      title: 'Silencing Shot',
      description: {
        1: 'A shot that deals 50% weapon damage and Silences the target for 3 sec. Non-player victim spellcasting is also interrupted for 3 sec.',
      },
      icon: `${RESOURCE_URI}/icons/large/ability_theblackarrow.jpg`,
      tier: 9,
      column: 2,
      max: 1,
      castDuration: 'instant',
      costs: '6% of base mana',
      cooldown: 20,
      range: 35,
      required: 'hunter_marksmanship_master_marksman',
    }, {
      id: 'hunter_marksmanship_improved_steady_shot',
      title: 'Improved Steady Shot',
      description: {
        1: 'Your Steady Shot hits have a 5% chance to increase the damage done by your next Aimed Shot, Arcane Shot or Chimera Shot by 15%, and reduce the mana cost of your next Aimed Shot, Arcane Shot or Chimera Shot by 20%.',
        2: 'Your Steady Shot hits have a 10% chance to increase the damage done by your next Aimed Shot, Arcane Shot or Chimera Shot by 15%, and reduce the mana cost of your next Aimed Shot, Arcane Shot or Chimera Shot by 20%.',
        3: 'Your Steady Shot hits have a 15% chance to increase the damage done by your next Aimed Shot, Arcane Shot or Chimera Shot by 15%, and reduce the mana cost of your next Aimed Shot, Arcane Shot or Chimera Shot by 20%.',
      },
      icon: `${RESOURCE_URI}/icons/large/ability_hunter_improvedsteadyshot.jpg`,
      tier: 9,
      column: 3,
      max: 3,
    }, {
      id: 'hunter_marksmanship_marked_for_death',
      title: 'Marked for Death',
      description: {
        1: 'Increases your damage done by your shots and the damage done by your pet\'s special abilities by 1% on marked targets, and increases the critical strike damage bonus of your Aimed Shot, Arcane Shot, Steady Shot, Kill Shot and Chimera Shot by 2%.',
        2: 'Increases your damage done by your shots and the damage done by your pet\'s special abilities by 2% on marked targets, and increases the critical strike damage bonus of your Aimed Shot, Arcane Shot, Steady Shot, Kill Shot and Chimera Shot by 4%.',
        3: 'Increases your damage done by your shots and the damage done by your pet\'s special abilities by 3% on marked targets, and increases the critical strike damage bonus of your Aimed Shot, Arcane Shot, Steady Shot, Kill Shot and Chimera Shot by 6%.',
        4: 'Increases your damage done by your shots and the damage done by your pet\'s special abilities by 4% on marked targets, and increases the critical strike damage bonus of your Aimed Shot, Arcane Shot, Steady Shot, Kill Shot and Chimera Shot by 8%.',
        5: 'Increases your damage done by your shots and the damage done by your pet\'s special abilities by 5% on marked targets, and increases the critical strike damage bonus of your Aimed Shot, Arcane Shot, Steady Shot, Kill Shot and Chimera Shot by 10%.',
      },
      icon: `${RESOURCE_URI}/icons/large/ability_hunter_assassinate.jpg`,
      tier: 10,
      column: 2,
      max: 5,
    }, {
      id: 'hunter_marksmanship_chimera_shot',
      title: 'Chimera Shot',
      description: {
        1: 'You deal 125% weapon damage, refreshing the current Sting on your target and triggering an effect: Serpent Sting - Instantly deals 40% of the damage done by your Serpent Sting. Viper Sting - Instantly restores mana to you equal to 60% of the total amount drained by your Viper Sting. Scorpid Sting - Attempts to Disarm the target for 10 sec. This effect cannot occur more than once per 1 minute.',
      },
      icon: `${RESOURCE_URI}/icons/large/ability_hunter_chimerashot2.jpg`,
      tier: 11,
      column: 2,
      max: 1,
      costs: '12% of base mana',
      cooldown: 10,
      range: 35,
    },
  ],
}, {
  title: 'survival',
  backgroundImage: `${RESOURCE_URI}/talents/backgrounds/wrath/362.jpg`,
  icon: `${RESOURCE_URI}/icons/large/ability_hunter_swiftstrike.jpg`,
  talents: [
    {
      id: 'hunter_survival_improved_tracking',
      title: 'Improved Tracking',
      description: {
        1: 'While tracking Beasts, Demons, Dragonkin, Elementals, Giants, Humanoids and Undead, all damage done to those types by the Hunter is increased by 1%.',
        2: 'While tracking Beasts, Demons, Dragonkin, Elementals, Giants, Humanoids and Undead, all damage done to those types by the Hunter is increased by 2%.',
        3: 'While tracking Beasts, Demons, Dragonkin, Elementals, Giants, Humanoids and Undead, all damage done to those types by the Hunter is increased by 3%.',
        4: 'While tracking Beasts, Demons, Dragonkin, Elementals, Giants, Humanoids and Undead, all damage done to those types by the Hunter is increased by 4%.',
        5: 'While tracking Beasts, Demons, Dragonkin, Elementals, Giants, Humanoids and Undead, all damage done to those types by the Hunter is increased by 5%.',
      },
      icon: `${RESOURCE_URI}/icons/large/ability_hunter_improvedtracking.jpg`,
      tier: 1,
      column: 1,
      max: 5,
    },
    {
      id: 'hunter_survival_hawk_eye',
      title: 'Hawk Eye',
      description: {
        1: 'Increases the range of your ranged weapons by 2 yards.',
        2: 'Increases the range of your ranged weapons by 4 yards.',
        3: 'Increases the range of your ranged weapons by 6 yards.',
      },
      icon: `${RESOURCE_URI}/icons/large/ability_townwatch.jpg`,
      tier: 1,
      column: 2,
      max: 3,
    }, {
      id: 'hunter_survival_savage_strikes',
      title: 'Savage Strikes',
      description: {
        1: 'Increases the critical strike chance of Raptor Strike, Mongoose Bite and Counterattack by 10%.',
        2: 'Increases the critical strike chance of Raptor Strike, Mongoose Bite and Counterattack by 20%.',
      },
      icon: `${RESOURCE_URI}/icons/large/ability_racial_bloodrage.jpg`,
      tier: 1,
      column: 3,
      max: 2,
    }, {
      id: 'hunter_survival_surefooted',
      title: 'Surefooted',
      description: {
        1: 'Reduces the duration of movement impairing effects by 10%.',
        2: 'Reduces the duration of movement impairing effects by 20%.',
        3: 'Reduces the duration of movement impairing effects by 30%.',
      },
      icon: `${RESOURCE_URI}/icons/large/ability_kick.jpg`,
      tier: 2,
      column: 1,
      max: 3,
    }, {
      id: 'hunter_survival_entrapment',
      title: 'Entrapment',
      description: {
        1: 'When your Frost Trap or Snake Trap are triggered you entrap all afflicted targets, preventing them from moving for 2 sec.',
        2: 'When your Frost Trap or Snake Trap are triggered you entrap all afflicted targets, preventing them from moving for 3 sec.',
        3: 'When your Frost Trap or Snake Trap are triggered you entrap all afflicted targets, preventing them from moving for 4 sec.',
      },
      icon: `${RESOURCE_URI}/icons/large/spell_nature_stranglevines.jpg`,
      tier: 2,
      column: 2,
      max: 3,
    }, {
      id: 'hunter_survival_trap_mastery',
      title: 'Trap Mastery',
      description: {
        1: 'Frost Trap and Freezing Trap - Increases the duration by 10%. Immolation Trap, Explosive Trap and Black Arrow - Increases the periodic damage done by 10%. Snake Trap - Increases the number of snakes summoned by 2.',
        2: 'Frost Trap and Freezing Trap - Increases the duration by 20%. Immolation Trap, Explosive Trap and Black Arrow - Increases the periodic damage done by 20%. Snake Trap - Increases the number of snakes summoned by 4.',
        3: 'Frost Trap and Freezing Trap - Increases the duration by 30%. Immolation Trap, Explosive Trap and Black Arrow - Increases the periodic damage done by 30%. Snake Trap - Increases the number of snakes summoned by 6.',
      },
      icon: `${RESOURCE_URI}/icons/large/ability_ensnare.jpg`,
      tier: 2,
      column: 3,
      max: 3,
    }, {
      id: 'hunter_survival_survival_instincts',
      title: 'Survival Instincts',
      description: {
        1: 'Reduces all damage taken by 2% and increases the critical strike chance of your Arcane Shot, Steady Shot, and Explosive Shot by 2%.',
        2: 'Reduces all damage taken by 4% and increases the critical strike chance of your Arcane Shot, Steady Shot, and Explosive Shot by 4%.',
      },
      icon: `${RESOURCE_URI}/icons/large/ability_hunter_survivalinstincts.jpg`,
      tier: 2,
      column: 4,
      max: 2,
    }, {
      id: 'hunter_survival_survivalist',
      title: 'Survivalist',
      description: {
        1: 'Increases your Stamina by 2%.',
        2: 'Increases your Stamina by 4%.',
        3: 'Increases your Stamina by 6%.',
        4: 'Increases your Stamina by 8%.',
        5: 'Increases your Stamina by 10%.',
      },
      icon: `${RESOURCE_URI}/icons/large/spell_shadow_twilight.jpg`,
      tier: 3,
      column: 1,
      max: 5,
    }, {
      id: 'hunter_survival_scatter_shot',
      title: 'Scatter Shot',
      description: {
        1: 'A short-range shot that deals 50% weapon damage and disorients the target for 4 sec. Any damage caused will remove the effect. Turns off your attack when used.',
      },
      icon: `${RESOURCE_URI}/icons/large/ability_golemstormbolt.jpg`,
      tier: 3,
      column: 2,
      max: 1,
      cooldown: 30,
      range: 15,
      costs: '8% of base mana',
    }, {
      id: 'hunter_survival_deflection',
      title: 'Deflection',
      description: {
        1: 'Increases your chance to parry by 1%, and reduces the duration of all Disarm effects used against you by 16%. This does not stack with other Disarm duration reducing effects.',
        2: 'Increases your chance to parry by 2%, and reduces the duration of all Disarm effects used against you by 25%. This does not stack with other Disarm duration reducing effects.',
        3: 'Increases your chance to parry by 3%, and reduces the duration of all Disarm effects used against you by 50%. This does not stack with other Disarm duration reducing effects.',
      },
      icon: `${RESOURCE_URI}/icons/large/ability_parry.jpg`,
      tier: 3,
      column: 3,
      max: 3,
    }, {
      id: 'hunter_survival_survival_tactics',
      title: 'Survival Tactics',
      description: {
        1: 'Reduces the chance your Feign Death ability and all trap spells will be resisted by 2%, and reduces the cooldown of your Disengage ability by 2 sec.',
        2: 'Reduces the chance your Feign Death ability and all trap spells will be resisted by 4%, and reduces the cooldown of your Disengage ability by 4 sec.',
      },
      icon: `${RESOURCE_URI}/icons/large/ability_rogue_feigndeath.jpg`,
      tier: 3,
      column: 4,
      max: 2,
    }, {
      id: 'hunter_survival_tnt',
      title: 'T.N.T.',
      description: {
        1: 'Increases the damage done by your Explosive Shot, Explosive Trap, Black Arrow and Immolation Trap by 2%.',
        2: 'Increases the damage done by your Explosive Shot, Explosive Trap, Black Arrow and Immolation Trap by 4%.',
        3: 'Increases the damage done by your Explosive Shot, Explosive Trap, Black Arrow and Immolation Trap by 6%.',
      },
      icon: `${RESOURCE_URI}/icons/large/inv_misc_bomb_05.jpg`,
      tier: 4,
      column: 2,
      max: 3,
    }, {
      id: 'hunter_survival_lock_and_load',
      title: 'Lock and Load',
      description: {
        1: 'You have a 33% chance when you trap a target with Freezing Trap, Freezing Arrow or Frost Trap and a 2% chance when you deal periodic damage with your Immolation Trap, Explosive Trap or Black Arrow to cause your next 2 Arcane Shot or Explosive Shot spells to trigger no cooldown, cost no mana and consume no ammo. This effect has a 22 sec cooldown.',
        2: 'You have a 66% chance when you trap a target with Freezing Trap, Freezing Arrow or Frost Trap and a 4% chance when you deal periodic damage with your Immolation Trap, Explosive Trap or Black Arrow to cause your next 2 Arcane Shot or Explosive Shot spells to trigger no cooldown, cost no mana and consume no ammo. This effect has a 22 sec cooldown.',
        3: 'You have a 100% chance when you trap a target with Freezing Trap, Freezing Arrow or Frost Trap and a 6% chance when you deal periodic damage with your Immolation Trap, Explosive Trap or Black Arrow to cause your next 2 Arcane Shot or Explosive Shot spells to trigger no cooldown, cost no mana and consume no ammo. This effect has a 22 sec cooldown.',
      },
      icon: `${RESOURCE_URI}/icons/large/ability_hunter_lockandload.jpg`,
      tier: 4,
      column: 4,
      max: 3,
    }, {
      id: 'hunter_survival_hunter_vs_wild',
      title: 'Hunter vs. Wild',
      description: {
        1: 'Increases you and your pet\'s attack power and ranged attack power equal to 10% of your total Stamina.',
        2: 'Increases you and your pet\'s attack power and ranged attack power equal to 20% of your total Stamina.',
        3: 'Increases you and your pet\'s attack power and ranged attack power equal to 30% of your total Stamina.',
      },
      icon: `${RESOURCE_URI}/icons/large/ability_hunter_huntervswild.jpg`,
      tier: 5,
      column: 1,
      max: 3,
      required: 'hunter_survival_survivalist',
    }, {
      id: 'hunter_survival_killer_instinct',
      title: 'Killer Instinct',
      description: {
        1: 'Increases your critical strike chance with all attacks by 1%.',
        2: 'Increases your critical strike chance with all attacks by 2%.',
        3: 'Increases your critical strike chance with all attacks by 3%.',
      },
      icon: `${RESOURCE_URI}/icons/large/spell_holy_blessingofstamina.jpg`,
      tier: 5,
      column: 2,
      max: 3,
    }, {
      id: 'hunter_survival_counterattack',
      title: 'Counterattack',
      description: {
        1: 'A strike that becomes active after parrying an opponent\'s attack. This attack deals (Attack power * 0.2 + 48) damage and immobilizes the target for 5 sec. Counterattack cannot be blocked, dodged, or parried.',
      },
      icon: `${RESOURCE_URI}/icons/large/ability_warrior_challange.jpg`,
      tier: 5,
      column: 3,
      max: 1,
      castDuration: 'instant',
      costs: '3% of base mana',
      range: 0,
      cooldown: 5,
      required: 'hunter_survival_deflection',
    }, {
      id: 'hunter_survival_lightning_reflexes',
      title: 'Lightning Reflexes',
      description: {
        1: 'Increases your Agility by 3%.',
        2: 'Increases your Agility by 6%.',
        3: 'Increases your Agility by 9%.',
        4: 'Increases your Agility by 12%.',
        5: 'Increases your Agility by 15%.',
      },
      icon: `${RESOURCE_URI}/icons/large/spell_nature_invisibilty.jpg`,
      tier: 6,
      column: 1,
      max: 5,
    }, {
      id: 'hunter_survival_resourcefulness',
      title: 'Resourcefulness',
      description: {
        1: 'Reduces the mana cost of all traps, melee abilities and Black Arrow by 20% and reduces the cooldown of all traps and Black Arrow by 2 sec.',
        2: 'Reduces the mana cost of all traps, melee abilities and Black Arrow by 40% and reduces the cooldown of all traps and Black Arrow by 4 sec.',
        3: 'Reduces the mana cost of all traps, melee abilities and Black Arrow by 60% and reduces the cooldown of all traps and Black Arrow by 6 sec.',
      },
      icon: `${RESOURCE_URI}/icons/large/ability_hunter_resourcefulness.jpg`,
      tier: 6,
      column: 3,
      max: 3,
    }, {
      id: 'hunter_survival_expose_weakness',
      title: 'Expose Weakness',
      description: {
        1: 'Your ranged criticals have a 33% chance to grant you Expose Weakness. Expose Weakness increases your attack power by 25% of your Agility for 7 sec.',
        2: 'Your ranged criticals have a 66% chance to grant you Expose Weakness. Expose Weakness increases your attack power by 25% of your Agility for 7 sec.',
        3: 'Your ranged criticals have a 100% chance to grant you Expose Weakness. Expose Weakness increases your attack power by 25% of your Agility for 7 sec.',
      },
      icon: `${RESOURCE_URI}/icons/large/ability_rogue_findweakness.jpg`,
      tier: 7,
      column: 1,
      max: 3,
      required: 'hunter_survival_lightning_reflexes',
    }, {
      id: 'hunter_survival_wyvern_sting',
      title: 'Wyvern Sting',
      description: {
        1: 'A stinging shot that puts the target to sleep for 30 sec. Any damage will cancel the effect. When the target wakes up, the Sting causes 300 Nature damage over 6 sec. Only one Sting per Hunter can be active on the target at a time.',
      },
      icon: `${RESOURCE_URI}/icons/large/inv_spear_02.jpg`,
      tier: 7,
      column: 2,
      max: 1,
      cooldown: 60,
      costs: '8% of base mana',
      range: 35,
      required: 'hunter_survival_killer_instinct',
    }, {
      id: 'hunter_survival_thrill_of_the_hunt',
      title: 'Thrill of the Hunt',
      description: {
        1: 'Gives you a 33% chance to regain 40% of the mana cost of any shot when it critically hits.',
        2: 'Gives you a 66% chance to regain 40% of the mana cost of any shot when it critically hits.',
        3: 'Gives you a 100% chance to regain 40% of the mana cost of any shot when it critically hits.',
      },
      icon: `${RESOURCE_URI}/icons/large/ability_hunter_thrillofthehunt.jpg`,
      tier: 7,
      column: 3,
      max: 3,
    }, {
      id: 'hunter_survival_master_tactician',
      title: 'Master Tactician',
      description: {
        1: 'Your successful ranged attacks have a 2% chance to increase your critical strike chance with all attacks by 10% for 8 sec.',
        2: 'Your successful ranged attacks have a 4% chance to increase your critical strike chance with all attacks by 10% for 8 sec.',
        3: 'Your successful ranged attacks have a 6% chance to increase your critical strike chance with all attacks by 10% for 8 sec.',
        4: 'Your successful ranged attacks have a 8% chance to increase your critical strike chance with all attacks by 10% for 8 sec.',
        5: 'Your successful ranged attacks have a 10% chance to increase your critical strike chance with all attacks by 10% for 8 sec.',
      },
      icon: `${RESOURCE_URI}/icons/large/ability_hunter_mastertactitian.jpg`,
      tier: 8,
      column: 1,
      max: 5,
    }, {
      id: 'hunter_survival_noxious_stings',
      title: 'Noxious Stings',
      description: {
        1: 'If Wyvern Sting is dispelled, the dispeller is also afflicted by Wyvern Sting lasting 16% of the duration remaining, and increases all damage done by you on targets afflicted by your Serpent Sting by 1%.',
        2: 'If Wyvern Sting is dispelled, the dispeller is also afflicted by Wyvern Sting lasting 25% of the duration remaining, and increases all damage done by you on targets afflicted by your Serpent Sting by 2%.',
        3: 'If Wyvern Sting is dispelled, the dispeller is also afflicted by Wyvern Sting lasting 50% of the duration remaining, and increases all damage done by you on targets afflicted by your Serpent Sting by 3%.',
      },
      icon: `${RESOURCE_URI}/icons/large/ability_hunter_potentvenom.jpg`,
      tier: 8,
      column: 2,
      max: 3,
      required: 'hunter_survival_wyvern_sting',
    }, {
      id: 'hunter_survival_point_of_no_escape',
      title: 'Point of No Escape',
      description: {
        1: 'Increases the critical strike chance of all of your attacks on targets affected by your Frost Trap, Freezing Trap and Freezing Arrow by 3%.',
        2: 'Increases the critical strike chance of all of your attacks on targets affected by your Frost Trap, Freezing Trap and Freezing Arrow by 6%.',
      },
      icon: `${RESOURCE_URI}/icons/large/ability_hunter_pointofnoescape.jpg`,
      tier: 9,
      column: 1,
      max: 2,
    }, {
      id: 'hunter_survival_black_arrow',
      title: 'Black Arrow',
      description: {
        1: 'Fires a Black Arrow at the target, increasing all damage done by you to the target by 6% and dealing (Ranged attack power * 0.1 + 157 * 5) Shadow damage over 15 sec. Black Arrow shares a cooldown with Trap spells.',
      },
      icon: `${RESOURCE_URI}/icons/large/spell_shadow_painspike.jpg`,
      tier: 9,
      column: 2,
      max: 1,
      cooldown: 30,
      range: 35,
      costs: '6% of base mana',
    }, {
      id: 'hunter_survival_sniper_training',
      title: 'Sniper Training',
      description: {
        1: 'Increases the critical strike chance of your Kill Shot ability by 5%, and while standing still for 6 sec, you gain Sniper Training increasing the damage done by your Steady Shot, Aimed Shot, Black Arrow and Explosive Shot by 2% for 15 sec.',
        2: 'Increases the critical strike chance of your Kill Shot ability by 10%, and while standing still for 6 sec, you gain Sniper Training increasing the damage done by your Steady Shot, Aimed Shot, Black Arrow and Explosive Shot by 4% for 15 sec.',
        3: 'Increases the critical strike chance of your Kill Shot ability by 15%, and while standing still for 6 sec, you gain Sniper Training increasing the damage done by your Steady Shot, Aimed Shot, Black Arrow and Explosive Shot by 6% for 15 sec.',
      },
      icon: `${RESOURCE_URI}/icons/large/ability_hunter_longshots.jpg`,
      tier: 9,
      column: 4,
      max: 3,
    }, {
      id: 'hunter_survival_hunting_party',
      title: 'Hunting Party',
      description: {
        1: 'Increases your total Agility by an additional 1%, and your Arcane Shot, Explosive Shot and Steady Shot critical strikes have a 33% chance to grant up to 10 party or raid members mana regeneration equal to 1% of the maximum mana per 5 sec. Lasts for 15 sec.',
        2: 'Increases your total Agility by an additional 2%, and your Arcane Shot, Explosive Shot and Steady Shot critical strikes have a 66% chance to grant up to 10 party or raid members mana regeneration equal to 1% of the maximum mana per 5 sec. Lasts for 15 sec.',
        3: 'Increases your total Agility by an additional 3%, and your Arcane Shot, Explosive Shot and Steady Shot critical strikes have a 100% chance to grant up to 10 party or raid members mana regeneration equal to 1% of the maximum mana per 5 sec. Lasts for 15 sec.',
      },
      icon: `${RESOURCE_URI}/icons/large/ability_hunter_huntingparty.jpg`,
      tier: 10,
      column: 3,
      max: 3,
      required: 'hunter_survival_thrill_of_the_hunt',
    }, {
      id: 'hunter_survival_explosive_shot',
      title: 'Explosive Shot',
      description: {
        1: 'You fire an explosive charge into the enemy target, dealing (Ranged attack power * 0.14 + 144)-(Ranged attack power * 0.14 + 172) Fire damage. The charge will blast the target every second for an additional 2 sec.',
      },
      icon: `${RESOURCE_URI}/icons/large/ability_hunter_explosiveshot.jpg`,
      tier: 11,
      column: 2,
      max: 1,
      cooldown: 6,
      costs: '7% of base mana',
      range: 35,
      required: 'hunter_survival_black_arrow',
    },
  ],
}];
